exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.invoices[data-v-6ee55796] {\n  width: 0;\n}\n.v-select.v-text-field--enclosed:not(.v-text-field--single-line)\n  .v-select__selections[data-v-6ee55796] {\n  padding-top: 0 !important;\n}\naudio[data-v-6ee55796] {\n  outline: none;\n  width: 100%;\n}\n", ""]);

// exports
